import {
  TextField,
  Button,
  Typography,
  Box,
  Divider,
  Stack,
  IconButton,
  Collapse,
} from "@mui/material";
import { useAppDispatch, useAppSelector } from "../hooks/hooks";
import { getUsersTenancyName } from "../redux/userSlice";
import { externalLogin } from "../redux/authSlice";
import FacebookIcon from "@mui/icons-material/Facebook";
import { CredentialResponse, GoogleLogin } from "@react-oauth/google";
import FacebookLogin, { ReactFacebookLoginInfo } from "react-facebook-login";
import { PhoneIphone as PhoneIcon, ExpandMore } from "@mui/icons-material";
import { useState } from "react";

interface LoginFormProps {
  username: string;
  password: string;
  isAuthenticating: boolean;
  error?: string;
  displayMessages?: string;
  onUsernameChange: (value: string) => void;
  onPasswordChange: (value: string) => void;
  onSubmit: () => void;
  onSwitchToRegister: () => void;
  onSwitchToPhoneLogin: () => void;
  afterExternalLogin?: () => void;
}

export const LoginForm = ({
  username,
  password,
  isAuthenticating,
  error,
  displayMessages,
  onUsernameChange,
  onPasswordChange,
  onSubmit,
  onSwitchToRegister,
  onSwitchToPhoneLogin,
  afterExternalLogin,
}: LoginFormProps) => {
  const dispatch = useAppDispatch();
  const [showAlternateLogins, setShowAlternateLogins] = useState(false);
  const { chainType } = useAppSelector((state) => state.wallet);

  const handleUserNameOnBlur = () => {
    if (username.trim() === "") return;
    dispatch(getUsersTenancyName({ id: username.trim() }));
  };

  const responseFacebook = async (response: ReactFacebookLoginInfo) => {
    if (response.accessToken) {
      await dispatch(
        externalLogin({
          authProvider: "Facebook",
          providerAccessCode: response.accessToken,
          providerKey: process.env.REACT_APP_FACEBOOK_PROVIDER_KEY || "",
        })
      );
      afterExternalLogin?.();
    }
  };

  const handleFacebookFailure = (error: any) => {
    console.error("Facebook login failed:", error);
  };

  const responseMessage = async (response: CredentialResponse) => {
    await dispatch(
      externalLogin({
        authProvider: "Google",
        providerAccessCode: response.credential || "",
        providerKey: process.env.REACT_APP_GOOGLE_PROVIDER_KEY || "",
      })
    );
    afterExternalLogin?.();
  };

  return (
    <Box>
      <TextField
        label="Email"
        value={username}
        type="email"
        onChange={(e) => onUsernameChange(e.target.value)}
        onBlur={handleUserNameOnBlur}
        fullWidth
        sx={{ mb: 2 }}
      />

      <TextField
        label="Password"
        type="password"
        value={password}
        onChange={(e) => onPasswordChange(e.target.value)}
        fullWidth
        sx={{ mb: 2 }}
      />

      <Button
        variant="contained"
        onClick={onSubmit}
        disabled={isAuthenticating}
        fullWidth
        sx={{ mb: 2 }}
      >
        {isAuthenticating ? "Logging in..." : "Login"}
      </Button>

      <Box textAlign="center" sx={{ mb: 2 }}>
        <Typography variant="body2" component="span">
          New to {chainType === "evm" ? "Ndeipi" : "Believe in Unity"}?{" "}
        </Typography>
        <Button
          variant="text"
          onClick={onSwitchToRegister}
          sx={{ textTransform: "none", p: 0 }}
        >
          Sign up
        </Button>
      </Box>

      {/* 
      <Divider sx={{ my: 2 }}>or</Divider>

      <Box textAlign="center">
        <Button
          startIcon={<ExpandMore />}
          onClick={() => setShowAlternateLogins(!showAlternateLogins)}
          sx={{ mb: 2 }}
        >
          {showAlternateLogins ? "Hide options" : "Login options"}
        </Button>
      </Box>

      <Collapse in={showAlternateLogins}>
        <Stack
          direction="row"
          spacing={2}
          sx={{ alignItems: "center", justifyContent: "center", mb: 2 }}
        >
          <GoogleLogin
            onSuccess={responseMessage}
            onError={() => console.log("Login Failed")}
            type="icon"
            size="large"
          />
          <FacebookLogin
            appId={process.env.REACT_APP_FACEBOOK_APP_ID || ""}
            autoLoad={false}
            fields="name,email,picture"
            callback={responseFacebook}
            onFailure={handleFacebookFailure}
            cssClass="facebook-login-button"
            icon={<FacebookIcon />}
            textButton=""
            buttonStyle={{
              width: "42px",
              height: "42px",
              borderRadius: "4px",
              backgroundColor: "#fff",
            }}
          />
          <IconButton
            onClick={onSwitchToPhoneLogin}
            sx={{
              width: "40px",
              height: "40px",
              borderRadius: "4px",
              backgroundColor: "#fff",
            }}
          >
            <PhoneIcon sx={{ color: "#000" }} />
          </IconButton>
        </Stack>
      </Collapse> */}

      {error && <Typography color="error">{error}</Typography>}
      {displayMessages && (
        <Typography color="info">{displayMessages}</Typography>
      )}
    </Box>
  );
};
